import React from "react";
import { NavLink, Outlet, useGlobalController, BCMSRecord, useStateManager, useModel } from "bcms-react";
import Classes, { TransferTransaction } from "model";
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from "components/shared";
import PendingApprovalPage from "./components/PendingApprovalPage";
import "./styles.css";
import "./mobile.css";
import CustomContentHeaderWidget from "components/shared/views/CustomContentHeaderWidget";

export default function TransferActivityPage(props) {
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(), ...props.ui ?? {} };

    const state = { data, ui };
    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui
    });

    return (
        <PageContainer className="transfer-activity-page" state={ state } controller={ controller }>
            <TransferActivityContent />
        </PageContainer>
    )
}

export const getDefaultPageData = () => ({
  scheduledTransfers: TransferTransaction.initAll().filter(transfer => transfer.status === "scheduled", []),
  pendingApprovalTransfers: TransferTransaction.initAll().filter(transfer => transfer.needsApproval, []),
});
export const getDefaultPageUI = () => ({
  content: undefined,

  scheduledTransfers: { isActive: false },
  transferHistory: { isActive: false },
  pendingApproval: { isActive: false }
});

function TransferActivityContent(props) {
    const { data, ui } = useStateManager();
    const Component = ui.content;
    const { branding } = useModel();
    const subHeaderContent = branding.options.transfer_activity_subheader_abi22;
    const promoText = branding.options.transfer_activity_promo_abi22;
    const pendingApprovalTransfers = data.pendingApprovalTransfers;
    const hasPendingApprovalTransfers = pendingApprovalTransfers.length > 0;
    let transfers = data.scheduledTransfers;

    if(Component === PendingApprovalPage && hasPendingApprovalTransfers) {
      transfers = pendingApprovalTransfers;
    }

    return (
        <PageContentView>
          <div className="flex-container flex-vertical page-widget-wrapper">
            {promoText && <CustomContentHeaderWidget content = {promoText}/>}
            
            <CenterContentContainer>
                <ContentHeaderView text="Transfer Activity" />
                {subHeaderContent && <CustomContentHeaderWidget content = {subHeaderContent}/>}
                <TransferActivityTabsView />

                { ui.content === undefined ? <Outlet /> : <Component transfers={ transfers } /> }
            </CenterContentContainer>
          </div>
        </PageContentView>
    )
}

function TransferActivityTabsView(props) {
    const { data, ui } = useStateManager();
    
    const scheduledActive = ui.content !== undefined && ui.scheduledTransfers.isActive ? "active-item" : "";
    const transferActive = ui.content !== undefined && ui.transferHistory.isActive ? "active-item" : "";
    const pendingApprovalActive = ui.content !== undefined && ui.pendingApproval.isActive ? "active-item" : "";
    const pendingApprovalTransfers = data.pendingApprovalTransfers;
    const hasPendingApprovalTransfers = pendingApprovalTransfers.length > 0;

    return(
      <div className="transfer-activity-tabs-view flex-container">        
        <NavLink dataPoint="Transfer_Activity_Scheduled" className={`tab set-width ${ scheduledActive }`} activeClassName="active-item" activeRoutes={["/transferActivity/scheduledTransfers"]} to="/transferActivity/scheduledTransfers">
          SCHEDULED
        </NavLink>
        <NavLink dataPoint="Transfer_Activity_History" className={`tab set-width ${ transferActive }`} activeClassName="active-item" activeRoutes={["/transferActivity/transferHistory"]} to="/transferActivity/transferHistory">
          HISTORY
        </NavLink>
        { hasPendingApprovalTransfers && 
        <NavLink dataPoint="Transfer_Activity_Pending_Approvals" className={`tab set-width pending-approval-tab ${ pendingApprovalActive }`} activeClassName="active-item" activeRoutes={["/transferActivity/pendingApproval"]} to="/transferActivity/pendingApproval">
          <div className="flex-container flex-horizontal align-center pending-approvals-tab-content flex-width">
            <p>PENDING APPROVAL</p>
            <div className="notification-bubble set-width show-on-desktop">
              { pendingApprovalTransfers.length }
            </div>
            <div className="mobile-notification-dot set-width show-on-mobile"></div>
          </div>
        </NavLink>
        }
      </div>
    );
  }